<template>
  <div class="foreword">
    <img src="@/assets/1.png" class="headline" alt="">
    <div class="forewordContent">
      <div class="desc">我们的生活每一天都离不开能源。但从2021年开始，欧洲却爆发了一次大规模的能源危机。这次危机暴露了欧洲能源发展中的哪些问题，又对我们有什么启示呢？几位同学围绕这一问题展开了探究。请你跟随这些同学，开始一次研究历程吧！  </div>
      <div class="ask">同学们上网找到了两则视频。观看这两则视频，了解常见的能源类型以及欧洲能源危机的现状。  </div>
      <div class="video">
        <VideoModule :onlyId="'energy01'" :videoArr='videoArr' :key="1"></VideoModule>
        <VideoModule :onlyId="'energy02'" :videoArr='videoArr2' :key="2"></VideoModule>
      </div>
      <div class="videoTrext">
        <div>《各种能源的分类》</div>
        <div>《欧洲能源危机现状》</div>
      </div>
      <div v-if="energy01 && energy02" class="next" @click="forewordNext">开始作答</div>
    </div>
  </div>
</template>
<script>
import VideoModule from '../components/video.vue'
export default {
  components: {
    VideoModule
  },
  data() {
    return {
      energy01: false,
      energy02: false,
      videoArr: [
        {
          isControl: true,
          autoPlay: false,
          isloop: false,
          isImg: true,
          url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/54_63071fd099dad/116790b6a52fbd1f5877a024ef11eb02.mp4'
        }
      ],
      videoArr2: [
        {
          isControl: true,
          autoPlay: false,
          isloop: false,
          isImg: true,
          url: 'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/60_638c3d9d9f2ca/4f7355d247ae197fb8a6c3e22822889d.mp4'
        }
      ]
    }
  },
  methods: {
    videoEnd(str) {
      this[str] = true
    },
    forewordNext() {
      this.$parent.go()
    }
  },
}
</script>
<style lang="less" scoped>
  .foreword{
    width: 100%;
    > .headline{
      height: 60px;
      display: block;
      margin: 0 auto;
      margin-bottom: 20px;
    }
    .forewordContent{
      width: 100%;
      background: #fff;
      border-radius: 14px;
      padding: 26px 28px 60px 28px;
      box-sizing: border-box;
      .desc{
        font-size: 18px;
        font-weight: 700;
        color: #000000;
        line-height: 30px;
        text-indent: 2em;
      }
      .ask{
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        line-height: 30px;
        margin-top: 20px;
        text-indent: 2em;
      }
      .video{
        display: flex;
        width: 100%;
        margin: 0 auto;
        justify-content: space-between;
        margin-top: 46px;
        > div{
          width: 50%;
        }
      }
      .videoTrext{
        display: flex;
        margin-top: 22px;
        div{
          width: 50%;
          text-align: center;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #000000;
          line-height: 27px;
        }
      }
      .next {
      width: 269px;
      height: 44px;
      background: #f8f9ff;
      border-radius: 22px;
      display: flex;
      background: var(--button-bg-color);
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 20px;
      margin: 0 auto;
      margin-top: 37px;
      cursor: pointer;
    }
    }
  }
</style>
